export default __webpack_public_path__ + "static/media/GWCrop.31f22912.pdf";